export default {
  MirrorBlogUrl: "https://mirror.xyz/mintkudosxyz.eth",
  DiscordInviteUrl: "https://discord.com/invite/v8JtC7sGuG",
  TwitterUrl: "https://twitter.com/mintkudosXYZ",
  CalendlyUrl: "https://calendly.com/catherine-contributionlabs/30min-1",
  DevelopersUrl: "https://developers.mintkudos.xyz ",
  DocumentationUrl: "https://docs.mintkudos.xyz",
};
